module.exports = __webpack_public_path__ + "img/4-oneImg.e69e3a26.png";